import React from "react";
import style from "./NavBar.module.css";
import { Link } from "react-router-dom";
function NavBar() {
  return (
    <div className={style.mainContainer}>
      <div className={style.leftContainer}>
        <h2 className={style.topics}>TOPICS</h2>
      </div>
      <div className={style.linksDiv}>
        <Link to="/blog/application-software" className={style.links}>
          Applications & Software
        </Link>
        <Link to="/blog/creative" className={style.links}>
          Creative
        </Link>
        <Link to="/blog/custom-software" className={style.links}>
          Custom Software
        </Link>
        <Link to="/blog/e-commerce" className={style.links}>
          E-Commerce
        </Link>
        <Link to="/blog/education" className={style.links}>
          Education
        </Link>
        <Link to="/blog/finance" className={style.links}>
          Finance
        </Link>
        <Link to="/blog/food-grocery" className={style.links}>
          Food & Grocery
        </Link>
        <Link to="/blog/healthcare" className={style.links}>
          Healthcare
        </Link>
        <Link to="/blog/home-service" className={style.links}>
          Home Service Apps
        </Link>
        <Link to="/blog/internal-communication" className={style.links}>
          Internal Communication
        </Link>
        <Link to="/blog/security" className={style.links}>
          Security
        </Link>
        <Link to="/blog/tech" className={style.links}>
          Tech
        </Link>
        <Link to="/blog/travel" className={style.links}>
          Travel Apps
        </Link>
        <Link to="/blog/ui-ux" className={style.links}>
          UI/UX
        </Link>
        <Link to="/blog/web-development" className={style.links}>
          Web Development
        </Link>
      </div>
    </div>
  );
}

export default NavBar;
